<template>
	<div class="top-alternatives">
		<div class="container">
            <h2 class="mb-5">{{ currentAlternative.title }}</h2>
            <div class="top-alternatives-wrapper">
                <div class="row">
                    <div class="col-md-3 mb-4 mb-md-0">
                        <div class="top-alternatives-tabs">
                            <div 
                                v-for="(tool, index) in currentAlternative.tools" 
                                :key="index" class="top-alternative-tab" 
                                :class="toolIndex == index ? 'active' : ''" 
                                @click="toolIndex = index"
                            >
                                {{tool.name}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div 
                            v-for="(tool, index) in currentAlternative.tools" 
                            :key="index" 
                            class="top-alternative-description" 
                            :class="toolIndex == index ? 'active' : ''"
                            v-html="tool.description"
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import alternatives from '../../../../public/js/alternatives/top-alternatives.json';
export default {
    props: ['alternative'],
    data() {
        return {
            toolIndex: 0
        };
    },
    computed: {
        currentAlternative() {
            return alternatives[this.alternative];
        },
        activeTool() {
            return alternatives[this.alternative]['tools'][this.toolIndex];
        }
    },
    methods: {
        // changeActiveTool(index) {
        //     this.activeTool = alternatives[this.alternative]['tools'][index];
        // }
    },
};
</script>
<style scoped lang="less">
.top-alternatives {
    padding: 80px 0;
    background-color: #FAFBFC;
}
.top-alternatives-wrapper {
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 60px;
    @media (max-width: 768px) {
        padding: 30px;
    }
}
.top-alternatives-tabs {
    border-left: 1px solid rgba(0, 0, 0, 0.14);
}
.top-alternative-tab {
    width: 100%;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.4);
    padding: 10px 0 8px 34px;
    cursor: pointer;
    &.active {
        background-color: #47BEFF;
        border-radius: 0px 8px 8px 0px;
        border-left: 7px solid #84DEFF;
        color: #fff;
        margin-left: -4px;
    }
    @media (max-width: 768px) {
        padding: 11px 0 7px 34px;
        margin-bottom: 10px;
    }
}
.top-alternative-description {
    max-height: 0;
    overflow: hidden;
    &.active {
        max-height: fit-content;
    }
}
</style>




// WEBPACK FOOTER //
// resources/js/frontend/components/TopAlternatives.vue